<template>
  <v-tabs
    v-show="showTabs"
    v-if="pageNames?.length > 0"
    id="form-tab-container"
    v-model="currentTab"
    background-color="#42b983"
    dark
    center-active
    show-arrows
  >
    <v-tabs-slider color="primary" />
    <v-tab
      v-for="(page, index) in pageNames"
      :key="index"
      :id="`tab-${index}`"
      :class="{ 'd-none': displayStatus(page.field) }"
      @click="updateCurrentTab(index)"
    >
      {{ page.name }}
      <v-icon
        v-if="pageWarnings[page.name] > 0"
        class="pl-1 pb-5" color="white">
        error
      </v-icon>
    </v-tab>
  </v-tabs>
</template>
<script>
import pageTabsMixin from '@/mixins/components/pageTabs.mixin';

export default {
  Name: 'PageTabs',

  mixins: [pageTabsMixin]
}
</script>
